import type React from "react";

/** A grid cell value with a small bar behind it, relative to the column maximum. */
export const PtV2SpendBar: React.FC<{ratio: number; color?: string; children: React.ReactNode}> = ({ratio, color, children}) => (
    <span className="ptv2-spendbar">
        <span className="ptv2-spendbar-track">
            <span className="ptv2-spendbar-fill"
                  style={{width: `${Math.min(100, Math.max(0, ratio * 100))}%`, background: color}}/>
        </span>
        <b className="ptv2-num">{children}</b>
    </span>
);
